module.exports = __webpack_public_path__ + "img/erjian-gaoji.98b87236.png";